module.exports = __webpack_public_path__ + "static/img/p1.697315d1.png";